export const INBOX_KEYBOARD_SHORTCUTS = {
  DELETE_CONV: {
    key: 'delete',
    description: 'Delete the currently selected conversation.',
  },
  TAG_CONV: {
    key: 't',
    description: 'Assign a tag to the currently selected conversation.',
  },
  SNOOZE_CONV: {
    key: 's',
    description: 'Snooze the currently selected conversation.',
  },
  GO_TO_PREV_CONV: {
    key: 'ArrowLeft',
    description: 'Navigate to the previous conversation (available in list view).',
  },
  GO_TO_NEXT_CONV: {
    key: 'ArrowRight',
    description: 'Navigate to the next conversation (available in list view).',
  },
  REPLY_CONV: {
    key: 'r',
    description: 'Reply to the most recent message in the selected conversation.',
  },
  FORWRD_CONV: {
    key: 'f',
    description: 'Forward the most recent message in the selected conversation.',
  },
  REPLY_WITH_AI_CONV: {
    key: 'i',
    description: 'Reply to the most recent message in the selected conversation using AI.',
  },
}

// export const INBOX_KEYBOARD_SHORTCUTS = {
//   DELETE_CONV: 'delete',
//   TAG_CONV: 't',
//   SNOOZE_CONV: 's',
//   GO_TO_PREV_CONV: 'ArrowLeft',
//   GO_TO_NEXT_CONV: 'ArrowRight',
//   REPLY_CONV: 'r',
//   FORWRD_CONV: 'f',
//   REPLY_WITH_AI_CONV: 'i',
// }
